<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <SalabamLoginPage :service_title="service_title" :service_name="service_name"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import SalabamLoginPage from '@/components/salabam/SalabamLoginPage'

export default {
  name: 'SalabamShop',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Voli Vadobay", link : 'conv-salabam-voli-vadobay' } ],

        // Nome welfarebit del servizio
        service_title : "Voli Vadobay",

        // Identificativo del servizio
        service_name : "voli-vadobay"
    }
  },
  components: {
    PageTagline,
    SalabamLoginPage
  }
}
</script>

<style scoped></style>